"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_THREAD_USERS_SORT_COLUMNS = [
    "id",
    "type",
    "email",
    "firstname",
    "lastname",
];
//# sourceMappingURL=get-thread-users-parameters.js.map